import getConfig from './Config';
export const getClassroomProviderData = (providerName) => {
  const passportProviders = getConfig()?.skooldioLogin?.passportProviders ?? [];
  return passportProviders.find(({ provider }) => provider === providerName);
};

export const getQuickAccessByProviderName = (providerName) => {
  const quickAccessByUserType = getConfig()?.myCourses?.quickAccessByUserType ?? [];
  return quickAccessByUserType.find(({ provider }) => provider === providerName);
};

export const getCourseSearchByProviderName = (providerName) => {
  const courseSearch = getConfig()?.myCourses?.courseSearch ?? [];
  return courseSearch.find(({ provider }) => provider === providerName);
};

export const getError = (errors = [], code) => {
  const error = errors.find(({ message }) => message.substring(0, 3) === code);
  return error;
};
